import { render } from "./bannerDetail.vue?vue&type=template&id=43249f99&scoped=true"
import script from "./bannerDetail.vue?vue&type=script&lang=js"
export * from "./bannerDetail.vue?vue&type=script&lang=js"

import "./bannerDetail.vue?vue&type=style&index=0&id=43249f99&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43249f99"]])

export default __exports__